import * as React from 'react';
import {MenuItemProps, Pagination} from "semantic-ui-react";
import Button from "../../../../Button";
import NumberOfItems from "./NumberOfItems";
import {PaginationProps} from "semantic-ui-react/dist/commonjs/addons/Pagination/Pagination";
import {scrollGridToTop} from "../../../VirtualizedTableUtils";

interface TablePaginationProps {
    numberOfItems: number;
    setNumberOfItems: (e: React.MouseEvent<HTMLAnchorElement>, data: MenuItemProps) => void;
    dataLength: number;
    filteredDataLength: number;
    t: reactI18Next.TranslationFunction;
    currentPage: number;
    onPageChange: (event: React.MouseEvent<HTMLAnchorElement>, data: PaginationProps) => void;
    customNoOfItems?: number[];
    hasScrollBtn: boolean;
    isNewTable?: boolean;
    records?:number;
    filterCount?: number;
    selectedCount?: number;
}

const TablePagination: React.SFC<TablePaginationProps> = (props: TablePaginationProps) => {
    return (
        <div className={`${props.isNewTable ? 'table-pagination-container_ag_grid ' : 'table-pagination-container'}`}>
            <NumberOfItems
                numberOfItems={props.numberOfItems}
                setNumberOfItems={props.setNumberOfItems}
                dataLength={props.dataLength}
                filteredDataLength={props.filteredDataLength}
                customNoOfItems={props.customNoOfItems}
                t={props.t}
                isNewTable={props.isNewTable}
                records={props.records}
                filterCount={props.filterCount}
                selectedCount={props.selectedCount}
            />
            {props.hasScrollBtn &&
                <Button
                    style={{height: 40}}
                    id={'scroll-top-btn'}
                    label={props.t('GLOBAL:SCROLLTOP')}
                    className={'margin--0'}
                    onClick={scrollGridToTop}
                />
            }
            {!props.isNewTable && <Pagination
                className='table-pagination-menu'
                activePage={props.currentPage}
                onPageChange={props.onPageChange}
                totalPages={Math.ceil(props.filteredDataLength / props.numberOfItems)}
            />}
        </div>
    );
};

export default TablePagination;



// WEBPACK FOOTER //
// ./src/components/Table/components/footerComponents/pagination/TablePagination.tsx